import * as React from "react"
import "./product-carousel.scss";
import {useEffect, useState} from "react";

async function validateImageUrl(url) {
    return new Promise(resolve => {
        const img = new Image();
        img.onload = () => resolve(url);
        img.onerror = () => resolve(false);
        img.src = url;
    });
}

export default function ProductImageCarousel({productImageList, autoplay = true, delay = 4}) {

    const [activeItem, setActiveItem] = useState(0);
    const [carouselDelay, setCarouselDelay] = useState(delay);
    const [validImageUrls, setValidImageUrls] = useState([]);
    const handleActiveImageItem = (goTo) => {
        setActiveItem(activeItem + goTo > validImageUrls.length - 1 ? 0 : (activeItem + goTo < 0 ? validImageUrls.length - 1 : activeItem + goTo));
        clearInterval(carouselAutoplay);

    }

    let carouselAutoplay;

    if (autoplay) {
        carouselAutoplay = setInterval(() => {
            if (autoplay) {
                handleActiveImageItem(+1)
            }
        }, carouselDelay * 1000);
    }
    useEffect(() => {
        const validateImages = async () => {
            const validatedUrls = await Promise.all(productImageList.map(validateImageUrl));
            setValidImageUrls(validatedUrls.filter(image=>!!image));
        };
        validateImages();
    }, [productImageList]);


    return (
        <div className={`product-image-carousel`}>

            <div className={`carousel-display`}>
                {validImageUrls.map((imageItem, index) => (
                    <div key={`image-${index}`}
                         className={`carousel-image-wrapper  ${index === activeItem ? 'active' : 'invisible'}`}>
                        <img src={imageItem} alt=""/>
                    </div>
                ))}
            </div>

            {validImageUrls.length > 1 && (
                <div className={`carousel-arrow-control`}>
                    <button className={`carousel-control-prev`} onClick={() => {
                        setCarouselDelay(999999);
                        handleActiveImageItem(-1)
                    }}>

                        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
                            <g data-name="Group 12" transform="rotate(180 23.058 22.88)">
                                <circle data-name="Ellipse 1" cx="23" cy="23" r="23" transform="translate(.115 -.24)"/>
                                <g data-name="Group 10">
                                    <path data-name="Path 3"
                                          fill="#000"
                                          d="M9.634 5.928 1.942.391A1.821 1.821 0 0 0 .931 0C.356 0 0 .485 0 1.3v11.964c0 .811.355 1.3.929 1.3a1.806 1.806 0 0 0 1.006-.392l7.7-5.537a1.677 1.677 0 0 0 .765-1.356 1.671 1.671 0 0 0-.766-1.351z"
                                          transform="translate(19.522 15.836)"/>
                                </g>
                            </g>
                        </svg>
                    </button>
                    <button className={`carousel-control-next`} onClick={() => {
                        setCarouselDelay(999999);
                        handleActiveImageItem(+1);
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
                            <g data-name="Group 11" transform="translate(-.097 -.063)">
                                <circle data-name="Ellipse 1" cx="23" cy="23" r="23" transform="translate(.097 .063)"/>
                                <g data-name="Group 10">
                                    <path data-name="Path 3"
                                          fill="#000"
                                          d="M71.154 5.928 63.462.391A1.821 1.821 0 0 0 62.451 0c-.575 0-.931.485-.931 1.3v11.964c0 .811.355 1.3.929 1.3a1.806 1.806 0 0 0 1.006-.392l7.7-5.537a1.677 1.677 0 0 0 .769-1.352 1.671 1.671 0 0 0-.77-1.355z"
                                          transform="translate(-44.103 15.823)"/>
                                </g>
                            </g>
                        </svg>
                    </button>
                </div>
            )}

            {validImageUrls.length > 1 && (
                <div className={`carousel-footer-control`}>
                    <div className={`pagination`}>
                        {validImageUrls.map((pageItem, index) => (
                            <div key={`page-${index}`}
                                 onClick={() => {
                                     setActiveItem(index)
                                 }}
                                 className={`page-item  ${index === activeItem ? 'active' : 'invisible'}`}>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}
